import React from 'react'
// import { useQuery } from 'react-query'

// import { HomeDepotLabel } from 'src/modules/supply_chain/components/retailers/HomeDepotLabel'
// import { skuit } from 'src/services/skuit'

export const PreviewLabelPage = () => {
  return (
    <div>
      This is a test.
    </div>
  )
}
